import {
  FETCH_USAGE_CONSUMPTION_APPROVERS_REQUEST,
  FETCH_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  FETCH_USAGE_CONSUMPTION_APPROVERS_ERROR,
  FETCH_USE_CONSUME_APPROVERS_REQUEST,
  FETCH_USE_CONSUME_APPROVERS_ERROR,
  FETCH_USE_CONSUME_APPROVERS_SUCCESS,
  UPDATE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
  UPDATE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  UPDATE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  CHANGE_USAGE_CONSUMPTION_APPROVERS_REQUEST,
  CHANGE_USAGE_CONSUMPTION_APPROVERS_SUCCESS,
  CHANGE_USAGE_CONSUMPTION_APPROVERS_ERROR,
  RESET_MENU_MISSIONS,
  RESET_EDIT_MENU_MISSION,
  GET_MENU_MISSION_FROM_LIST,
  REMOVE_MENU_MISSION_SUCCESS,
  REMOVE_MENU_MISSION_ERROR,
  CLEAR_SUCCESS_MESSAGE,
  FETCH_MISSIONS_OPTIONS_REQUEST,
  FETCH_MISSIONS_OPTIONS_SUCCESS,
  FETCH_MISSIONS_OPTIONS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
    options: [],
  },
  missions: {
    records: [],
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
  change: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
  },

  success: '',
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {

    case FETCH_USE_CONSUME_APPROVERS_REQUEST:
      return {
        ...state,
        missions: {
          ...state.missions,
          isFetching: true,
        },
      }

      case FETCH_USE_CONSUME_APPROVERS_SUCCESS:
      return {
        ...state,
        missions: {
          ...state.missions,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_USE_CONSUME_APPROVERS_ERROR:
      return {
        ...state,
        missions: {
          ...state.missions,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case FETCH_USAGE_CONSUMPTION_APPROVERS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_USAGE_CONSUMPTION_APPROVERS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_USAGE_CONSUMPTION_APPROVERS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case UPDATE_USAGE_CONSUMPTION_APPROVERS_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
          
        },
      }

    case UPDATE_USAGE_CONSUMPTION_APPROVERS_SUCCESS:
      return {
        ...state,
        success: 'usage-consumption-approvers.save.success',
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
          updated: true,
          removed: false,
        },
      }

    case UPDATE_USAGE_CONSUMPTION_APPROVERS_ERROR:
      return {
        ...state,
        success: '',
        change: {
          ...state.edit,
          isUpdating: false,
          error: action.payload,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case CHANGE_USAGE_CONSUMPTION_APPROVERS_REQUEST:
      return {
        ...state,
        change: {
          ...state.change,
          isUpdating: true,
          
        },
      }

      case CHANGE_USAGE_CONSUMPTION_APPROVERS_SUCCESS:
      return {
        ...state,
        
        change: {
          ...state.change,
          isUpdating: false,
          error: null,
          record: action.payload,
          updated: true,
          removed: false,
        },
      }

    case CHANGE_USAGE_CONSUMPTION_APPROVERS_ERROR:
      return {
        ...state,
        
        change: {
          ...state.change,
          isUpdating: false,
          error: action.payload,
          record: {},
          updated: true,
          removed: false,
        },
      }

    case RESET_MENU_MISSIONS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: null,
          options: []
        },
      }

    case RESET_EDIT_MENU_MISSION:
      return {
        ...state,
        edit: {
          isUpdating: false,
          error: null,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case GET_MENU_MISSION_FROM_LIST:
      const { index } = action
      const record = state.list.records[index]

      return {
        ...state,
        get: {
          ...state.get,
          record,
          error: null,
          isFetching: false,
        },
      }

    case REMOVE_MENU_MISSION_SUCCESS:
      return {
        ...state,
        success: 'usage-consumption-approvers.remove.success',
        edit: {
          ...state.edit,
          error: null,
          updated: false,
          removed: true,
        },
      }

    case REMOVE_MENU_MISSION_ERROR:
      return {
        ...state,
        success: '',
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          removed: false,
        },
      }

    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        success: '',
      }

    case FETCH_MISSIONS_OPTIONS_REQUEST:
      return {
        ...state,
      }

    case FETCH_MISSIONS_OPTIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          options: action.payload,
        },
      }

    case FETCH_MISSIONS_OPTIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          options: '',
        },
      }

    default:
      return state
  }
}

export default record
